import React from 'react';

import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { ProjectToolCall } from '../types';

interface ProjectCard extends LinkCardRecord {
  address: string | null;
  displayName: string | null;
}

interface ProjectCardsProps {
  toolCalls: ProjectToolCall[];
}

export function ProjectCards({ toolCalls }: ProjectCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.property}>
          {(project: ProjectCard) => (
            <>
              <div className="fw-semibold text-truncate">{project.displayName}</div>
              {project.address && <div className="small text-muted text-truncate">{project.address}</div>}
            </>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard
          index={index}
          key={index.path}
          label={index.label ?? 'projects'}
          pageName="Properties"
          theme={CARD_THEMES.property}
        />
      ))}
    </>
  );
}
